export interface BoqExplorerNode {
  id: string;
  label: string;
  category?: string;
  typeIds?: string[];
  catalogIds?: string[];
  children?: BoqExplorerNode[];
}

export const BOQ_EXPLORER_TREE: BoqExplorerNode[] = [
  { id: 'alignment', label: 'Alignment', catalogIds: ['road-corridor'] },
  {
    id: 'cross_sections',
    label: 'Cross Sections',
    typeIds: ['cross_section', 'camber'],
    catalogIds: ['road-camber'],
  },
  {
    id: 'pavement',
    label: 'Pavement Layers',
    category: 'pavement',
    typeIds: ['pavement'],
    catalogIds: ['road-pavement'],
  },
  {
    id: 'shoulders',
    label: 'Shoulders',
    category: 'shoulder',
    typeIds: ['shoulder'],
    catalogIds: ['road-shoulder'],
  },
  {
    id: 'structures',
    label: 'Structures',
    category: 'structure',
    catalogIds: ['road-structures'],
    children: [
      { id: 'bridge', label: 'Bridge', category: 'structure', typeIds: ['bridge', 'flyover', 'viaduct', 'rob', 'rub'] },
      { id: 'culvert', label: 'Culvert', category: 'structure', typeIds: ['culvert', 'box_culvert'] },
      { id: 'retaining_wall', label: 'Retaining wall', category: 'structure', typeIds: ['retaining_wall'] },
    ],
  },
  {
    id: 'furniture',
    label: 'Road Furniture',
    category: 'furniture',
    children: [
      { id: 'signage', label: 'Signage', category: 'furniture', typeIds: ['sign', 'sign_board'] },
      { id: 'barriers', label: 'Barriers', category: 'safety', typeIds: ['crash_barrier', 'guard_rail'] },
      { id: 'lighting', label: 'Lighting', category: 'furniture', typeIds: ['lighting'] },
    ],
  },
  {
    id: 'safety',
    label: 'Safety',
    category: 'safety',
    children: [
      { id: 'cctv', label: 'CCTV', category: 'safety', typeIds: ['cctv'] },
      { id: 'sos', label: 'Emergency phones', category: 'safety', typeIds: ['sos'] },
    ],
  },
  {
    id: 'utilities',
    label: 'Utilities',
    category: 'utility',
    children: [
      { id: 'water', label: 'Water', category: 'utility', typeIds: ['water'] },
      { id: 'ofc', label: 'OFC', category: 'utility', typeIds: ['ofc', 'utility_duct'] },
      { id: 'electric', label: 'Electric', category: 'utility', typeIds: ['electric_ht', 'electric_lt', 'electric_pole'] },
    ],
  },
  {
    id: 'toll',
    label: 'Toll Plaza',
    category: 'furniture',
    typeIds: ['toll_plaza'],
  },
];

export function flattenExplorerNodes(nodes: BoqExplorerNode[] = BOQ_EXPLORER_TREE): BoqExplorerNode[] {
  const out: BoqExplorerNode[] = [];
  const walk = (list: BoqExplorerNode[]) => {
    list.forEach((n) => {
      out.push(n);
      if (n.children?.length) walk(n.children);
    });
  };
  walk(nodes);
  return out;
}

export function defaultExplorerChecked(): Record<string, boolean> {
  const checked: Record<string, boolean> = {};
  flattenExplorerNodes().forEach((n) => {
    checked[n.id] = true;
  });
  return checked;
}
